import { TabNav, TabNavItem } from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const Navigation = () => {
    const { auth } = usePage().props;
    const { component } = usePage();

    return (
        <TabNav label='Pagina'>
            {auth.permissions?.includes('view questionnaires') && (
                <TabNavItem
                    as={Link}
                    href='/questionnaires/questions'
                    active={[
                        'Questionnaires/Questions/IndexView',
                        'Questionnaires/Questions/CreateOrUpdateView',
                    ]?.includes(component)}
                >
                    Vragen
                </TabNavItem>
            )}
            {auth.permissions?.includes('view questionnaires') && (
                <TabNavItem
                    as={Link}
                    href='/questionnaires/options'
                    active={[
                        'Questionnaires/Options/IndexView',
                        'Questionnaires/Options/CreateOrUpdateView',
                    ]?.includes(component)}
                >
                    Vragenlijst opties
                </TabNavItem>
            )}
            {auth.permissions?.includes('update questionnaires') && (
                <TabNavItem
                    as={Link}
                    href='/services/lkv/questionnaires'
                    active={['LKV/Questionnaires/CreateOrUpdateView']?.includes(
                        component
                    )}
                >
                    LKV vragenlijst instellingen
                </TabNavItem>
            )}
            {auth.permissions?.includes('update questionnaires') && (
                <TabNavItem
                    as={Link}
                    href='/services/no-risk/questionnaires'
                    active={[
                        'NoRisk/Questionnaires/CreateOrUpdateView',
                    ]?.includes(component)}
                >
                    No-riskpolis vragenlijst instellingen
                </TabNavItem>
            )}
            {auth.permissions?.includes('update questionnaires') && (
                <TabNavItem
                    as={Link}
                    href='/services/sroi/questionnaires'
                    active={[
                        'SROI/Questionnaires/CreateOrUpdateView',
                    ]?.includes(component)}
                >
                    SROI vragenlijst instellingen
                </TabNavItem>
            )}
        </TabNav>
    );
};

export default Navigation;
